import { render, staticRenderFns } from "./BuildingAndRoom.vue?vue&type=template&id=0fb64e70&scoped=true&"
import script from "./BuildingAndRoom.vue?vue&type=script&lang=js&"
export * from "./BuildingAndRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb64e70",
  null
  
)

export default component.exports